<mat-dialog-content>
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <div class="container">
    <form [formGroup]="menuForm">
      <div formGroupName="menu">
        <div class="d-flex flex-col flex-wrap">
          <mat-form-field appearance="outline">
            <mat-label>Nombre</mat-label>
            <input
              matInput
              placeholder="Nombre"
              formControlName="nombre"
              name="nombre"
              required
            />
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline">
          <mat-label>Descripción</mat-label>
          <textarea
            matInput
            placeholder="Descripcion"
            formControlName="descripcion"
            name="descripcion"
            cols="40"
            rows="5"
          ></textarea>
        </mat-form-field>
      </div>
      <mat-dialog-actions>
        <button mat-raised-button mat-dialog-close>Cancelar</button>
        <button mat-raised-button color="primary" (click)="createMenu()">
          Crear Menú
        </button>
      </mat-dialog-actions>
    </form>
  </div>
</mat-dialog-content>
